import GlobalNavigationShell from "components/v2/global-navigation-shell/GlobalNavigationShell";
import LoanCentricSidebarNav from "components/v2/loan-centric-sidebar-nav/LoanCentricSidebarNav";
import ShellProfileOverlay from "components/v2/shell-profile-overlay/ShellProfileOverlay";
import useDesktopChecker from "hooks/useDesktopChecker";
import useTabletChecker from "hooks/useTabletChecker";
import MyLoans from "pages/my-loans/MyLoans";

const MyLoansShellLayout = () => {
  const isDesktop = useDesktopChecker();
  const isTablet = useTabletChecker();
  const isMobilePhone = !isDesktop && !isTablet;

  return (
    <div className="dashboard-shell">
      <GlobalNavigationShell
        notificationsEnabled={false}
        shellContext="my-loans"
        hideFooter
        navSlot={!isMobilePhone ? <LoanCentricSidebarNav /> : undefined}
        navSlotPlacement="sidebar"
      >
        <ShellProfileOverlay>
          <MyLoans />
        </ShellProfileOverlay>
      </GlobalNavigationShell>
    </div>
  );
};

export default MyLoansShellLayout;
